<template>
  <SvgAsset v-if="iconContent" :content="iconContent" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SvgAsset from '../common/SvgAsset.vue'
import navBackSvg from '@/assets/inline-svg/nav-back.svg?raw'
import navFaqSvg from '@/assets/inline-svg/nav-faq.svg?raw'
import navFeedbackSvg from '@/assets/inline-svg/nav-feedback.svg?raw'
import navManualSvg from '@/assets/inline-svg/nav-manual.svg?raw'
import navMinSvg from '@/assets/inline-svg/nav-min.svg?raw'
import navOutSvg from '@/assets/inline-svg/nav-out.svg?raw'
import navSetSvg from '@/assets/inline-svg/nav-set.svg?raw'

const props = defineProps<{
  name: 'back' | 'faq' | 'manual' | 'feedback' | 'set' | 'min' | 'out'
}>()

const iconMap = {
  back: navBackSvg,
  faq: navFaqSvg,
  manual: navManualSvg,
  feedback: navFeedbackSvg,
  set: navSetSvg,
  min: navMinSvg,
  out: navOutSvg,
} satisfies Record<'back' | 'faq' | 'manual' | 'feedback' | 'set' | 'min' | 'out', string>

const iconContent = computed(() => iconMap[props.name])
</script>
